module.exports = __webpack_public_path__ + "static/media/time.169160c1.svg";